import React, { useEffect } from 'react'
import styles from './styles.module.scss'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { deleteItem, getList } from '../../actions/webLessons'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { AddEditModal } from './Components'
import Loader from '../../components/Loader'

export default function List() {

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { list, loading } = useSelector(state => state.web_lessons)

  const [modal, setModal] = useState(false)
  const [confirmation, setConfirmation] = useState(false);


  useEffect(() => {
    dispatch(getList());
  }, [])

  const goToCurrent = (id) => () => navigate(`/web_lessons/${id}`)

  const acceptConfirmation = () => {
    dispatch(deleteItem(confirmation.id));
    setConfirmation(false);
  };

  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const deleteClickHandler = (data) => (e) => {
    e.stopPropagation()
    setConfirmation(data)
  }

  const renderLi = (data) => {
    const { stream, id } = data
    return (
      <tr onClick={goToCurrent(id)}>
        <td>{stream}</td>
        <td><i className={styles.trash} onClick={deleteClickHandler(data)}><BiTrash /></i></td>
      </tr>
    )
  }

  if (loading) return <Loader/>;

  return (
    <div className={styles.wrapper}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation?.stream}?`}
          // confirmation={confirmation?.name} 
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      <h1>Открытые уроки</h1>
      <div style={{ margin: '2rem 0', backgroundColor: 'white' }}>
        <Table maxHeight='none'>
          <thead>
            <tr>
              <th>Название</th>
            </tr>
          </thead>
          <tbody>
            {list?.map(renderLi)}
          </tbody>
        </Table>
      </div>

      <Button
        style={{ padding: '.5rem 1.5rem' }}
        onClick={() => setModal(true)}
      >
        <IoIosAdd size={30} />
        Добавить
      </Button>
      <AddEditModal
        open={modal}
        closeModal={() => setModal(false)}
        addMode={true}
      />
    </div>
  )
}
